import React from 'react'
import {connect} from 'react-redux'
import {UniLink} from '../unilink/index'
import {showModal} from '../../../redux/modules/modal'
import {selectUserInfo, getLogout} from '../../../redux/modules/session'
import {toggleNavDropdown} from '../../../redux/modules/ui'

const MobileMenuComponent = ({dropdownIsToggled, isLoggedIn, userId, showRegister, showLogin, disableNavDropdown, logout}) => {
  return (
    <div onClick={disableNavDropdown} className={dropdownIsToggled ? `nav-mobile-menu nav-mobile-menu--active` : `nav-mobile-menu`}>
      <div className={dropdownIsToggled ? `nav-mobile-menu__overlay nav-mobile-menu__overlay--active` : `nav-mobile-menu__overlay`} />
      {
        isLoggedIn
          ? <div className={dropdownIsToggled ? `nav-mobile-menu__options nav-mobile-menu__options--active` : `nav-mobile-menu__options`}>
            <UniLink to="/" className="nav-mobile-menu__option" tabIndex="0">
              Home
            </UniLink>
            <div className="nav-mobile-menu__separator" />
            <UniLink to="/subjects" className="nav-mobile-menu__option" tabIndex="0">
              Subjects
            </UniLink>
            <UniLink to={`/user/${userId}/edit`} className="nav-mobile-menu__option" tabIndex="0">
              Settings
            </UniLink>
            <div className="nav-mobile-menu__separator" />
            <UniLink onClick={logout} className="nav-mobile-menu__option" tabIndex="0">
              Log out
            </UniLink>
          </div>
          : <div className={dropdownIsToggled ? `nav-mobile-menu__options nav-mobile-menu__options--active` : `nav-mobile-menu__options`}>
            <UniLink to="/" className="nav-mobile-menu__option" tabIndex="0">
              Home
            </UniLink>
            <div className="nav-mobile-menu__separator" />
            <UniLink onClick={showLogin} className="nav-mobile-menu__option" tabIndex="0">
              Log in
            </UniLink>
            <UniLink onClick={showRegister} className="nav-mobile-menu__option" tabIndex="0">
              Sign up
            </UniLink>
          </div>
      }
    </div>
  )
}

const mapStateToProps = state => {
  const userInfo = selectUserInfo(state)
  return {
    isLoggedIn: userInfo.isLoggedIn,
    userId: userInfo.user.get('id'),
    stateSearchEnabled: state.getIn(['ui', 'navSearchEnabled']),
    dropdownIsToggled: state.getIn(['ui', 'dropdownIsToggled'])
  }
}
const mapDispatchToProps = dispatch => {
  return {
    disableNavDropdown: () => dispatch(toggleNavDropdown(false)),
    showRegister: () => dispatch(showModal('REGISTER', {})),
    showLogin: () => dispatch(showModal('LOGIN', {})),
    logout: () => dispatch(getLogout())
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileMenuComponent)



// WEBPACK FOOTER //
// ./src/core/components/navbar/MobileMenu.js